export default {
  methods: {
    async $notify(msg) {
      this.global.notify = { msg, props: { color: 'primary', top: true, dark: true } };
    }
  }
}
